import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { WorkPage } from './pages/WorkPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { AdminPage } from './pages/AdminPage';
import { ScrollToTop } from './components/ScrollToTop';
import { WhatsAppButton } from './components/WhatsAppButton';
import { CustomCursor } from './components/CustomCursor';
import { trackSiteVisit } from './hooks/useAnalytics';
import { GoogleTranslateAutoInit } from './components/GoogleTranslate';
function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname === '/jhfdwrtooiowregdsg';
  // Track site visit once per session
  useEffect(() => {
    trackSiteVisit();
  }, []);
  return <div className="min-h-screen flex flex-col bg-[#F8F8F6]" data-id="element-0">
      {!isAdmin && <Navbar data-id="element-1" />}
      <div className="flex-1" data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/about" element={<AboutPage data-id="element-7" />} data-id="element-6" />
          <Route path="/services" element={<ServicesPage data-id="element-9" />} data-id="element-8" />
          <Route path="/services/:slug" element={<ServiceDetailPage data-id="element-11" />} data-id="element-10" />
          <Route path="/work" element={<WorkPage data-id="element-13" />} data-id="element-12" />
          <Route path="/blog" element={<BlogPage data-id="element-15" />} data-id="element-14" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-17" />} data-id="element-16" />
          <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
          <Route path="/terms" element={<TermsPage data-id="element-21" />} data-id="element-20" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-23" />} data-id="element-22" />
          <Route path="/jhfdwrtooiowregdsg" element={<AdminPage data-id="element-25" />} data-id="element-24" />
          <Route path="*" element={<NotFoundPage data-id="element-27" />} data-id="element-26" />
        </Routes>
      </div>
      {!isAdmin && <Footer data-id="element-28" />}
      {!isAdmin && <WhatsAppButton data-id="element-29" />}
    </div>;
}
export function App() {
  return <Router data-id="element-30">
      <ScrollToTop data-id="element-31" />
      <Toaster position="top-right" richColors closeButton data-id="element-32" />
      <GoogleTranslateAutoInit data-id="element-33" />
      <AppLayout data-id="element-34" />
    </Router>;
}